// agriflow/warehouse_new/static/js/index.js

import AlertHandler from "../../../assets/js/modules/alertHandler.js";
import "select2/dist/js/select2.full.min.js";
import { Modal } from "bootstrap";
import PickerManager from './module/picker-manager.js';

document.addEventListener('DOMContentLoaded', function () {
  if (typeof pickType === 'undefined' || typeof pickContainerId === 'undefined' || typeof pickDoc === 'undefined') return;
  const picker = new PickerManager();
  picker.renderPickTable(pickType, pickContainerId, pickDoc);
});

/* ------------------------------------------------------------------
   table configuration
------------------------------------------------------------------ */
const tableConfig = [


  /* ─────────────────────────────────────────────────────────────
    Storage-Overview (Produktübersicht)
  ───────────────────────────────────────────────────────────── */
  {
    selector: "#table-storage-overview",
    endpoint: "/api/warehouse_new/storage-overview/?start=0&length=50",
    columns: [
      { data: "storage_location_name", title: "Lagerplatz" },
      { data: "product_name", title: "Produkt" },
      { data: "quantity", title: "Bestand" },
      { data: "available_quantity", title: "Verfügbar" },
      { data: "reserved_quantity", title: "Reserviert" },
      { data: "batch_number", title: "Charge", defaultContent: "" },
      { data: "updated_at", title: "Zuletzt geändert" } 
    ],
    formType: "",
    dataUrl: id => ``,
    createBtn: ""
  },

  /* ─────────────────────────────────────────────────────────────
     Storage-Nodes  (Lagerplatz)
  ───────────────────────────────────────────────────────────── */
  {
    selector: "#table-storage-nodes",
    endpoint: "/api/warehouse_new/storage-nodes/?start=0&length=50",
    columns: [
      { data: "name",          title: "Name" },
      { data: "storage_type",  title: "Type" },
      { data: "capacity",      title: "Kapazität (m³)" },
      { data: "parent_name",   title: "Übergeordneter", defaultContent: "" },
      { data: "description",   title: "Beschreibung", defaultContent: "" },
      { data: "created_by",   title: "Erstellt von", defaultContent:"" },
      { data: "date_created", title: "Erstellungsdatum" },
      { data: "date_modified", title: "Änderungsdatum" }
    ],
    formType : "storage_nodes",
    dataUrl : id => `/api/warehouse_new/storage-nodes/${id}/`,
    deleteUrl : id => `/api/warehouse_new/storage-nodes/${id}/`, 
    createBtn  : "#btn-new-storage" 
  },

  /* ─────────────────────────────────────────────────────────────
     Stock-Movements (Lagerbewegungen)
  ───────────────────────────────────────────────────────────── */
  {
    selector: "#table-stock-movements",
    endpoint: "/api/warehouse_new/stock-transactions/?start=0&length=50", 
    columns: [
      { data: "id", visible:false },
      { data: "product", title: "Produkt" },
      { data: "storage_location", title:"Lagerplatz" },
      { data: "tx_type", title: "Buchungsart", defaultContent:""},
      { data: "quantity", title: "Menge" },
      { data: "created_by", title: "Gebucht von", defaultContent:"" },
      { data: "created_at", title: "Buchungszeit" },
    ],
    formType : "",
    dataUrl : id => ``,
    createBtn  : "" 
  },

  /* ─────────────────────────────────────────────────────────────
     Inventory (Bestandsverwaltung)
  ───────────────────────────────────────────────────────────── */
  {
    selector: "#table-inventory",
    endpoint: "/api/warehouse_new/product-stocks/?start=0&length=50",
    columns: [
      { data: "product_designation", title: "Produkt" },
      { data: "storage_location_name", title: "Lagerplatz" },
      { data: "batch_number", title: "Charge", defaultContent: "" },
      { data: "quantity", title: "Bestand" },
      { data: "reserved_quantity", title: "Reserviert" },
      { data: "available_quantity", title: "Verfügbar" },
      { data: "updated_at", title: "Aktualisiert" }
    ],
    formType : "",
    dataUrl : id => ``,
    createBtn  : "" 
  },

  /* ─────────────────────────────────────────────────────────────
     Transfers (Umlagerungen)
  ───────────────────────────────────────────────────────────── */
  {
    selector: "#table-transfers",
    endpoint: "/api/warehouse_new/transfers-list/",
    columns: [
      { "data": "product", "title": "Produkt" },
      { "data": "product_number", "title": "Produktnummer" },
      { "data": "quantity", "title": "Menge" },
      { "data": "storage_location_from", "title": "Von Lagerplatz" },
      { "data": "storage_location_to", "title": "Zu Lagerplatz" },
      { "data": "batch_number", "title": "Charge", defaultContent: "" },
      { "data": "created_by", "title": "Durchgeführt von" },
      { "data": "created_at", "title": "Datum" },
    ],
    formType: "stock_transfer",
    dataUrl: id => `/api/warehouse_new/transfers/`,
    createBtn: "#btn-new-transfer"
  }
];

let currentRow = null;
const dtInstances = [];


/* ------------------------------------------------------------------
   helpers
------------------------------------------------------------------ */
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


function buildFormUrl(formType) {
  return `/api/global/form/${formType}/`;
}

function hydrateForm(containerElement, dataObject) {
  Object.entries(dataObject).forEach(([key, value]) => {
    const field = containerElement.querySelector(`[name="${key}"]`);
    if (!field) return;
    if (field.type === "checkbox" || field.type === "radio") {
      field.checked = Boolean(value);
    } else {
      field.value = value ?? "";
    }
  });
}


/* ---------- enhance: select2 support -------------------------------- */
function initSelect2(scope) {
  if (!window.$ || !$.fn.select2) return;

  $(scope)
    .find("select.select2widget")
    .each(function () {
      const $el = $(this);
      if ($el.data("select2")) return;      // schon aktiv
      $el.select2({
        width      : "100%",
        theme      : "default",
        language   : "de",
        allowClear : true,
        placeholder: "",
        dropdownParent: $(scope)           // Dropdown bleibt im Modal
      });
    });
}


/* ---------- helper: set modal header -------------------------------- */
function setModalTitle(modalElement, schemaTitle, isUpdate) {
  const titleEl = modalElement.querySelector(".modal-title");
  if (!titleEl) return;
  const prefix  = isUpdate ? "Bearbeiten – " : "Neu – ";
  titleEl.textContent = `${prefix}${schemaTitle}`;
}


/* ---------- helper: Modal nur für CREATE --------------------------- */
async function openCreateModal(cfg, token) {
  const modalEl   = document.getElementById("crudModal");
  const modalBody = modalEl.querySelector(".modal-body");
  modalBody.textContent = "Loading …";

  const schema = await fetch(buildFormUrl(cfg.formType), {
    headers: { Authorization: `Token ${token}` }
  }).then(r => r.json());

  modalBody.innerHTML = "";
  const form = renderForm(schema); 
  form.dataset.formType = cfg.formType;
  modalBody.appendChild(form);
  
  setModalTitle(modalEl, schema.title, false);
  initSelect2(modalBody);

  Modal.getOrCreateInstance(modalEl).show();
}

/* ------------------------------------------------------------------
   schema → bootstrap-form
------------------------------------------------------------------ */
function renderForm(schemaObj) {
  const form = document.createElement("form");
  form.id = "dynamicForm";

  schemaObj.fields.forEach(field => {
    const wrapper = document.createElement("div");
    wrapper.className = "mb-3";

    const label = document.createElement("label");
    label.className = "form-label";
    label.textContent = field.label;
    wrapper.appendChild(label);

    let control;
    switch (field.type) {
      case "select":
        control = document.createElement("select");
        control.className = "form-select form-select-sm select2widget";
        if (Array.isArray(field.options)) {
          field.options.forEach(opt => {
            const option = document.createElement("option");
            option.value = opt.value;
            option.textContent = opt.label;
            control.appendChild(option);
          });
        }
        break;
      case "textarea":
        control = document.createElement("textarea");
        control.className = "form-control form-control-sm";
        break;
      default:
        control = document.createElement("input");
        control.className = "form-control form-control-sm";
        control.type = field.type === "number" ? "number" : "text";
    }
    control.name = field.name;
    if (field.required) control.required = true;
    wrapper.appendChild(control);

    form.appendChild(wrapper);
  });

  const saveBtn = document.createElement("button");
  saveBtn.type = "submit";
  saveBtn.className = "btn btn-sm btn-primary";
  saveBtn.textContent = "Speichern";
  form.appendChild(saveBtn);

  form.onsubmit = async (e) => { 
    e.preventDefault();
    
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    const isUpdate = currentRow && currentRow.id;
    const formType = form.dataset.formType; 
    const cfg = tableConfig.find(cfg => cfg.formType === formType);
    let baseUrl = "";

    switch (cfg.formType) {
      case "storage_nodes":
        baseUrl = "/api/warehouse_new/storage-nodes/";
        break;
      case "stock_transfer":
        baseUrl = "/api/warehouse_new/transfers/";
        break;
      default:
        console.error('Unbekannter Formulartyp');
        return;
    }

    const method = isUpdate ? 'PUT' : 'POST';
    const url = isUpdate ? `${baseUrl}${currentRow.id}/` : baseUrl;
    
    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${getCookie('drfToken')}`
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        const modal = document.getElementById("crudModal");
        Modal.getInstance(modal).hide();
        const config = tableConfig.find(c => c.formType === "storage_nodes");
        const table = $(config.selector).DataTable();
        table.ajax.reload();
      }

    } catch (error) {
      console.error('Fehler:', error);
    }
  }

  queueMicrotask(() => {
    initSelect2(form);
    setupDynamicStorageSelection(form);
  });

  return form;
}


/* ---------- helper: Dynamische Lagerplatz-Auswahl -------------------------------- */
function setupDynamicStorageSelection(form) {
  
  $(form).on('select2:select', '[name="product"]', async function(e) {

    const sourceLocationSelect = form.querySelector('[name="source_location"]');
    if (!sourceLocationSelect) return;
    
    const productId = e.params.data.id;
    
    if (!productId) {
      sourceLocationSelect.innerHTML = '<option value="">Bitte erst Produkt auswählen</option>';
      $(sourceLocationSelect).trigger('change');
      return;
    }

    try {
      const response = await fetch(
        `/api/warehouse_new/dynamic/storage-locations/?product_id=${productId}`, {
        headers: {
          'Authorization': `Token ${getCookie('drfToken')}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();        
        sourceLocationSelect.innerHTML = '<option value="">Lagerplatz auswählen</option>';
        
        data.choices.forEach(choice => {
          const option = document.createElement('option');
          option.value = choice.value;
          option.textContent = choice.label;
          sourceLocationSelect.appendChild(option);
        });
        
        // Select2 neu initialisieren
        $(sourceLocationSelect).trigger('change');
      }
    } catch (error) {
      console.error('Fehler beim Laden der Lagerplätze:', error);
    }
    
  });
}


/* ------------------------------------------------------------------
   main: init tables
------------------------------------------------------------------ */
function initTables() {
  const accessToken = getCookie('drfToken');

  tableConfig.forEach(cfg => {
    const dt = $(cfg.selector).DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      ajax: {
        url: cfg.endpoint,
        dataSrc: "data",
        headers: {                                   
          'Content-Type': 'application/json',
          'Authorization': `Token ${accessToken}`,
        }
      },
      columns: cfg.columns,
      pageLength: 50, 
      lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "Alle"]],
      language: {
        "decimal":        ",",
        "emptyTable":    "Keine Daten verfügbar",
        "info":          "_START_ bis _END_ von _TOTAL_ Einträgen",
        "infoEmpty":     "0 bis 0 von 0 Einträgen",
        "infoFiltered":  "(gefiltert von _MAX_ Einträgen)",
        "lengthMenu":    "_MENU_ Einträge anzeigen",
        "loadingRecords": "Lädt...",
        "processing":    "Bitte warten...",
        "search":        "Suchen:",
        "zeroRecords":   "Keine passenden Einträge gefunden",
        'paginate': {
            'next': '<i class="fas fa-angle-right"></i>',
            'previous': '<i class="fas fa-angle-left"></i>',
            'first': '<i class="fas fa-angle-double-left"></i>',
            'last': '<i class="fas fa-angle-double-right"></i>'
        }
    },
    });
    dtInstances.push(dt);

    const tbodyPath = `${cfg.selector} tbody`;
    const tbody = document.querySelector(tbodyPath);
    if (!tbody) return;  
    
    if (cfg.createBtn) {
      const btn = document.querySelector(cfg.createBtn);
      if (btn) {
        btn.addEventListener("click", () => openCreateModal(cfg, accessToken));
      }
    }

    tbody.addEventListener("click", async e=>{
      const tr=e.target.closest("tr");
      if(!tr) return;

      const row=dt.row(tr).data();
      if(!row) return;
      currentRow = row;

      const modalEl   = document.getElementById("crudModal");
      const modalBody = modalEl.querySelector(".modal-body");
      modalBody.textContent="Loading …";

      const schemaResponse = await fetch(buildFormUrl(cfg.formType), {
        headers: { Authorization: `Token ${accessToken}` }
      });

      const schemaObj = await schemaResponse.json(); 
      modalBody.innerHTML = "";  
      const form = renderForm(schemaObj);
      form.dataset.formType = cfg.formType;
      modalBody.appendChild(form);

      setModalTitle(modalEl, schemaObj.title ?? "Formular", Boolean(row.id));


      const isUpdate = Boolean(row.id);
      const showDeleteButton = isUpdate && cfg.formType == 'storage_nodes' && cfg.deleteUrl;

      if (showDeleteButton) {
        const deleteBtn = document.createElement("button");
        deleteBtn.type = "button";
        deleteBtn.className = "btn btn-sm btn-outline-danger ms-2";
        deleteBtn.innerHTML = '<i class="fas fa-trash"></i> Löschen';
        deleteBtn.onclick = () => handleDelete(cfg, currentRow.id);
        form.appendChild(deleteBtn);
      }


      if (row.id && cfg.dataUrl) {
        const dataResp = await fetch(cfg.dataUrl(row.id), {
          headers: { 
            'Content-Type': 'application/json',
            Authorization: `Token ${accessToken}`,
          }
        });
        const record = await dataResp.json();
        hydrateForm(modalBody, record);                   
      }



      Modal.getOrCreateInstance(modalEl).show();

    });

  });
}


document.addEventListener("DOMContentLoaded", () => {
  const tableExists = tableConfig.some(cfg =>
    document.querySelector(cfg.selector)
  );
  if (tableExists) {
    initTables();
  }
});






/* ------------------------------------------------------------------
   Delete Handler mit Bestätigung und Fehlerbehandlung
------------------------------------------------------------------ */
async function handleDelete(cfg, itemId) {

  try {
    const response = await fetch(`/api/warehouse_new/storage-nodes/${itemId}/`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Token ${getCookie('drfToken')}`,
        'Content-Type': 'application/json'
      }
    });

    let result = null;
    try {
      result = await response.json();
    } catch (parseError) {
      console.error("Server gab kein JSON zurück (500-Error)", parseError);
    }

    if (response.ok) {      
      const modal = document.getElementById("crudModal");
      Modal.getInstance(modal).hide();
      const table = $(cfg.selector).DataTable();
      table.ajax.reload();
      AlertHandler.showAlert(result.message, 'success');
    } else {
      const modal = document.getElementById("crudModal");
      Modal.getInstance(modal).hide();
      AlertHandler.showAlert(result.message, 'danger');
    }

  } catch (error) {
    console.error('Fehler beim Löschen:', error);
  }
}